// Local translations
export const T = {
  en_GB: {
    waiting: (language: string) => `Waiting to start · translating to ${language}`,
    translating: (language: string, done: string, total: string) =>
      `Translating to ${language} · ${done} of ${total} texts`,
    saving: "Saving the copy…",
    failed: "The copy failed",
    cancel: "Cancel",
    dismiss: "Dismiss",
    removeFailed: "The copy could not be removed",
  },
  nb_NO: {
    waiting: (language: string) => `Venter på å starte · oversettes til ${language}`,
    translating: (language: string, done: string, total: string) =>
      `Oversetter til ${language} · ${done} av ${total} tekster`,
    saving: "Lagrer kopien …",
    failed: "Kopieringen mislyktes",
    cancel: "Avbryt",
    dismiss: "Lukk",
    removeFailed: "Kopien kunne ikke fjernes",
  },
} as const;
